// Shared helpers used across the Nutrition Log card + its sub-components.

export function localDayISO() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function fmtNum(n) {
  if (n == null || Number.isNaN(n)) return "0";
  return Math.round(Number(n)).toLocaleString();
}

export function fmtTime(iso, tz) {
  try {
    return new Intl.DateTimeFormat(undefined, { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
  } catch {
    return "";
  }
}

export const MEAL_GROUP_META = {
  breakfast: { label: "Breakfast", emoji: "🍳" },
  lunch:     { label: "Lunch",     emoji: "🥗" },
  dinner:    { label: "Dinner",    emoji: "🍲" },
  snack:     { label: "Snack",     emoji: "🍎" },
  other:     { label: "Other",     emoji: "🍽️" },
};

export const MEAL_GROUP_ORDER = ["breakfast", "lunch", "dinner", "snack", "other"];
